(function($) {

    jQuery(document).on('elementor/popup/show', (event, id, instance) => {        
        const POPUP_SMS_CONFIRM_ID = 258;
        switch (id) {
            case POPUP_SMS_CONFIRM_ID:
                let phone = jQuery('#form-field-telephone').val();
                // console.log(`Teléfono: ${phone}`);
                jQuery('#phone-number').text(phone);
                jQuery('#form-field-telephone_hidden').val(phone);
                if(Cookie.get('mbra_id') && Cookie.get('mbra_id') !== 'undefined' && jQuery('#form-field-mbra_hidden')){
                    jQuery('#form-field-mbra_hidden').val(Cookie.get('mbra_id'));
                }
                jQuery.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: send_invitaciones.url,
                    data: {
                        action: 'regenerate_sms_code',
                        telephone: phone,
                        force: true
                    },
                    error: (xhr, status, error) => {
                        // let data = JSON.parse(xhr.responseJSON['data']);
                        // console.log(xhr);
                    },
                    success: (response) => {
                        let fiveMinutes = 60 * 5;
                        let display = jQuery('.confirmar-sms-timer-js')[0];
                        let activate = jQuery('#regenerate_sms_code');
                        let deactivate = jQuery('#tetramf_sms_validator .elementor-field-type-submit')[0];
                        startTimer(fiveMinutes,display,activate,deactivate);
                        jQuery(activate).toggleClass('isDisabled');
                    }
                });

                jQuery('#regenerate_sms_code').on('click',e => {
                    e.preventDefault();
                    let telf = jQuery('#form-field-telephone_hidden').val();
                    if(!jQuery(e.target).hasClass('isDisabled')){
                        jQuery.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: send_invitaciones.url,
                            data: {
                                action: 'regenerate_sms_code',
                                telephone: telf,
                            },
                            error: (xhr, status, error) => {
                                // let data = JSON.parse(xhr.responseJSON['data']);
                                // console.log(xhr);
                            },
                            success: (response) => {
                                let fiveMinutes = 60 * 5;
                                let display = jQuery('.confirmar-sms-timer-js')[0];
                                let activate = jQuery('#regenerate_sms_code');
                                let deactivate = jQuery('#tetramf_sms_validator .elementor-field-type-submit')[0];
                                startTimer(fiveMinutes,display,activate,deactivate);
                                jQuery(activate).toggleClass('isDisabled');
                            }
                        });
                    }
                });


                jQuery('#change_phone_number').on('click', function(e){
                    e.preventDefault();
                    document.querySelector('.eicon-close').click();
                    jQuery('#form-field-telephone').select();
                });

                break;
             
        }

         if((event.currentTarget.activeElement.form != undefined && jQuery(event.currentTarget.activeElement.form).attr('id')=='pregunta_aleatoria') 
            || (jQuery(event.currentTarget.activeElement).is('body') 
                && (instance.elementHTML != undefined && jQuery(instance.elementHTML).find('#popup_incorrecta_explicacio_respuesta').length >0 
                    || jQuery(instance.elementHTML).find('#popup_correcta_explicacio_respuesta').length >0 )) ){
            if(jQuery('#popup_incorrecta_explicacio_respuesta').length>0){
                jQuery('#popup_incorrecta_explicacio_respuesta').trigger('click');
            }
            if(jQuery('#popup_correcta_explicacio_respuesta').length>0){
                jQuery('#popup_correcta_explicacio_respuesta').trigger('click');
            }
            let test_id =0;
            if(jQuery(event.currentTarget.activeElement).is('body')){
                test_id= jQuery(event.currentTarget.activeElement).find('#form-field-id_pregunta').val()
            }else{
                test_id = jQuery(event.currentTarget.activeElement.form[4]).val();
            }
            jQuery.ajax({
                type: 'POST',
                dataType: 'json',
                url: tetramf_wpengine.url,
                data: {
                    action: 'get_explicacion_pregunta',
                    test_id: test_id,
                },
                error: (xhr, status, error) => {
                    console.log(xhr);
                },
                success: (response) => {
                    if(jQuery('#popup_incorrecta_explicacio_respuesta').length>0){
                        jQuery('#popup_incorrecta_explicacio_respuesta .elementor-heading-title').html(response.data);
                    }
                    if(jQuery('#popup_correcta_explicacio_respuesta').length>0){
                        jQuery('#popup_correcta_explicacio_respuesta .elementor-heading-title').html(response.data);
                    }
                }
            });
        }
        if(instance.elementHTML.includes('pregunta_aleatoria')){
            if(jQuery('#pregunta_aleatoria').length > 0){
                jQuery.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: tetramf_wpengine.url,
                    data: {
                        action: 'get_form_pregunta_aleatoria',
                    },
                    error: (xhr, status, error) => {
                        console.log(xhr);
                    },
                    success: (response) => {
                        jQuery('#form-field-id_pregunta').val(response.data['id_pregunta']);
                        jQuery('#pregunta_aleatoria .elementor-field-type-html .pregunta-texto-js').html(response.data['pregunta-texto-js']);
                        jQuery('#pregunta_aleatoria .elementor-field-type-radio .elementor-field-subgroup').html(response.data['pregunta_respuestas']);
                        jQuery('#pregunta_aleatoria .elementor-form-fields-wrapper input').click(e => {
                            jQuery('#pregunta_aleatoria').trigger('submit');
                        })
                    }
                });
            }
        }
    });
    let startTimer = function (duration, display,activate =undefined,deactivate =undefined) {
        var timer = duration, minutes, seconds;
        var intervalTimer =setInterval(function () {
            minutes = parseInt(timer / 60, 10)
            seconds = parseInt(timer % 60, 10);
    
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
    
            display.textContent = minutes + ":" + seconds;
    
            if (--timer < 0) {
                clearInterval(intervalTimer);
                if(activate!== undefined){
                    jQuery(activate).toggleClass('isDisabled');
                }
                if(deactivate!== undefined){
                    jQuery(deactivate).toggleClass('isDisabled');
                    jQuery(deactivate).prop('disabled', true);
                }    
            }
        }, 1000);
    }

})(jQuery);